const quizNextButton = document.querySelector('.question-controller #nextBtn')
const quizPrevButton = document.querySelector('.question-controller #prevBtn')

const questionController = document.querySelector('.question-controller')

const allQuestionBoxes = document.querySelectorAll('.question-box')
const allStepButtons = document.querySelectorAll('.selection-step-bar span')

const stepButtonWrapper = document.querySelector('.selection-step-bar')
const quizQuestionHolder = document.querySelector('.question-box-wrapper')
const quizResultHolder = document.querySelector('.quiz-result-wrapper')
const quizResultHeading = document.querySelector('.quiz-result-heading')

const loadingSpinnerSVG = document.querySelector('.quiz-loading-spinner')

const all_product_in_store = document.querySelectorAll('.quiz-product-wrapper .all_product_in_store > li')


const scoringArray = [
  {
    answer: "A milestone achievement",
    scores: { 10166661087524: 10, 10166659219748: 8, 10166657188132: 7, 10166656991524: 6, 10221045612836: 5 }
  },
  {
    answer: "A love story",
    scores: { 10221045612836: 10, 10166660366628: 10, 10166657712420: 8, 10166654402852: 7, 10166658400548: 6 }
  },
  {
    answer: "Personal transformation",
    scores: { 10166657188132: 10, 10166661087524: 8, 10166659219748: 8, 10166657712420: 7, 10166656991524: 6 }
  },
  {
    answer: "Family legacy",
    scores: { 10166660366628: 10, 10166657712420: 10, 10166657089828: 10, 10221045612836: 8, 10166654402852: 8 }
  },
  {
    answer: "Pure self-expression",
    scores: { 10166659219748: 10, 10166657188132: 10, 10166661087524: 8, 10166657712420: 7, 10166656991524: 5 }
  },
  {
    answer: "Classic elegance that transcends time",
    scores: { 10221045612836: 10, 10166660366628: 9, 10166658400548: 7, 10166657089828: 6, 10166654402852: 5 }
  },
  {
    answer: "Modern sophistication with clean lines",
    scores: { 10166661087524: 10, 10166656991524: 10, 10166657188132: 8, 10221045612836: 5, 10166658400548: 6 }
  },
  {
    answer: "Bohemian artistry with organic textures",
    scores: { 10166657712420: 9, 10166657089828: 8, 10166657188132: 8, 10166654402852: 7, 10166658400548: 6 }
  },
  {
    answer: "Bold statement that commands attention",
    scores: { 10166659219748: 10, 10166657188132: 9, 10166661087524: 7, 10166660366628: 6, 10166654402852: 5 }
  },
  {
    answer: "Vintage romance with intricate details",
    scores: { 10166660366628: 10, 10166654402852: 10, 10166657089828: 8, 10221045612836: 6, 10166657712420: 5 }
  },
  {
    answer: "Daily elegance for everyday luxury",
    scores: { 10166658400548: 10, 10166656991524: 10, 10221045612836: 8, 10166661087524: 7, 10166657712420: 6 }
  },
  {
    answer: "Special occasions and celebrations",
    scores: { 10166660366628: 10, 10166659219748: 9, 10221045612836: 8, 10166654402852: 7, 10166657188132: 7 }
  },
  {
    answer: "Professional power and confidence",
    scores: { 10166661087524: 10, 10166656991524: 9, 10221045612836: 8, 10166657188132: 7, 10166658400548: 6 }
  },
  {
    answer: "Intimate moments and personal joy",
    scores: { 10166657712420: 10, 10166658400548: 9, 10221045612836: 7, 10166657089828: 7, 10166660366628: 6 }
  },
  {
    answer: "Social events where I want to shine",
    scores: { 10166659219748: 10, 10166660366628: 9, 10166657188132: 8, 10166654402852: 7, 10166661087524: 6 }
  },
  {
    answer: "Incorporates meaningful symbols or stones",
    scores: { 10166657712420: 10, 10166657089828: 9, 10166660366628: 7, 10166654402852: 6, 10221045612836: 5 }
  },
  {
    answer: "Tells my personal story through design",
    scores: { 10166657712420: 10, 10166657188132: 9, 10166661087524: 7, 10166659219748: 6, 10166657089828: 6 }
  },
  {
    answer: "Reflects my heritage or culture",
    scores: { 10166657089828: 10, 10166654402852: 10, 10166660366628: 8, 10166657712420: 7, 10221045612836: 5 }
  },
  {
    answer: "Represents my individual style evolution",
    scores: { 10166657188132: 10, 10166661087524: 9, 10166659219748: 8, 10166656991524: 7, 10166658400548: 6 }
  },
  {
    answer: "Captures a specific memory or feeling",
    scores: { 10166657712420: 10, 10166660366628: 8, 10221045612836: 7, 10166657089828: 7, 10166658400548: 6 }
  },
  {
    answer: "A lifetime treasure to pass down generations",
    scores: { 10166660366628: 10, 10221045612836: 10, 10166657089828: 9, 10166654402852: 8, 10166657712420: 7 }
  },
  {
    answer: "The perfect expression of my success",
    scores: { 10166661087524: 10, 10166659219748: 9, 10166657188132: 8, 10221045612836: 7, 10166656991524: 6 }
  },
  {
    answer: "An artwork that reflects my sophistication",
    scores: { 10166657188132: 10, 10166661087524: 9, 10166654402852: 8, 10166659219748: 7, 10166660366628: 6 }
  },
  {
    answer: "A symbol of my most important relationships",
    scores: { 10221045612836: 10, 10166660366628: 10, 10166657712420: 9, 10166657089828: 7, 10166658400548: 6 }
  },
  {
    answer: "The ultimate reward for my achievements",
    scores: { 10166659219748: 10, 10166661087524: 9, 10166657188132: 8, 10221045612836: 7, 10166656991524: 6 }
  }
];


// --- RESTORE STATE --- //
let seletedRadioValues = JSON.parse(localStorage.getItem("quizAnswers")) || {};
let flag = parseInt(localStorage.getItem("quizFlag")) || 0;
let reachedResultPage = localStorage.getItem("onResultPage");

const quizResultWrapper = document.querySelector('.quiz-result-wrapper');
const quizProductItems = document.querySelectorAll('.quiz-product-wrapper .all_product_in_store > li');

// --- UTILITY FUNCTIONS --- //
function getUserInfo() {
  const params = new URLSearchParams(window.location.search);
  return {
    name: params.get("name"),
    email: params.get("email")
  };
}

function saveState() {
  localStorage.setItem("quizFlag", flag);
  localStorage.setItem("quizAnswers", JSON.stringify(seletedRadioValues));
}

function handlePrevVisibility() {
  flag === 0
    ? quizPrevButton.classList.add('hidden')
    : quizPrevButton.classList.remove('hidden');
}

// --- STORE SELECTED RADIO --- //
function handleOutput(flag) {
  if (flag <= allQuestionBoxes.length - 1) {
    const currentBox = allQuestionBoxes[flag];
    const currentQuestion = currentBox.querySelector('.question').dataset.question;
    const radio = currentBox.querySelector('input[type="radio"]:checked');
    seletedRadioValues[currentQuestion] = radio ? radio.value : null;
    saveState();
  }
}

function handleStepProgress(flag) {
  allStepButtons.forEach((box, index) => {
    box.classList.toggle('active', index <= flag);
  });
}

function updateNextButtonState() {
  const currentBox = allQuestionBoxes[flag];
  const radio = currentBox.querySelector('input[type="radio"]:checked');
  quizNextButton.disabled = !radio;
  return !!radio;
}

function showResultPage() {
  stepButtonWrapper.classList.add('hidden');
  quizQuestionHolder.classList.add('hidden');
  questionController.classList.add('hidden');
  quizResultWrapper.classList.remove('hidden');
  quizResultHeading.classList.remove('hidden');
}

// --- Insert "You Might Also Love" Heading --- //
function insertLoveHeading() {
  const existingHeading = document.querySelector('.quiz-product-wrapper .love-heading');
  if (existingHeading) existingHeading.remove();

  const firstRankedLi = document.querySelector('.quiz-product-wrapper .all_product_in_store > li[style*="--rank: 1"]');
  if (!firstRankedLi) return;

  const newHeading = document.createElement('h3');
  newHeading.textContent = 'You Might Also Love';
  newHeading.classList.add('love-heading');
  firstRankedLi.after(newHeading);
}

// --- Display top products and assign rank --- //
function showTopProducts(top3Ids) {
  quizProductItems.forEach(item => {
    const rankIndex = top3Ids.indexOf(item.dataset.productId);
    if (rankIndex !== -1) {
      item.classList.remove('hidden');
      item.style.setProperty('--rank', rankIndex + 1);
    } else {
      item.classList.add('hidden');
      item.style.removeProperty('--rank');
    }
  });
  insertLoveHeading();
}

// --- Restore Radio Input States --- //
function restoreInputsState() {
  allQuestionBoxes.forEach(box => {
    const currentQuestion = box.querySelector('.question').dataset.question;
    const radios = box.querySelectorAll('input[type="radio"]');

    radios.forEach(radio => {
      radio.checked = seletedRadioValues[currentQuestion] === radio.value;
    });
  });
  updateNextButtonState();
}

// --- MAIN LOGIC: Send Data & Calculate Top Products --- //
function sendDataToAPI() {
  const userData = getUserInfo();
  const quizAnswers = JSON.parse(localStorage.getItem('quizAnswers')) || {};

  const quizAnswersWithSequence = Object.entries(quizAnswers).map(([question, answer], index) => ({
    question,
    answer,
    sequence: index + 1
  }));

  const payload = { ...userData, answers: quizAnswersWithSequence };

  fetch("https://new.magento-development.asia/jda-jewellery-quiz/quiz-submit", {
    method: "POST",
    body: JSON.stringify(payload)
  })
  .then(response => response.json())
  .then(data => {
    if (data.status === "success") {
      const answersFromLocalStorage = Object.values(JSON.parse(localStorage.getItem('quizAnswers') || '{}'));
      const selectedAnsObj = [];

      answersFromLocalStorage.forEach(userAnswer => {
        const match = scoringArray.find(obj => obj.answer.toLowerCase() === userAnswer.toLowerCase());
        if (match) selectedAnsObj.push(match);
      });

      const scores = {};
      selectedAnsObj.forEach(a => {
        for (let id in a.scores) {
          scores[id] = (scores[id] || 0) + a.scores[id];
        }
      });

      // ✅ Only rank active/available products
      const availableIds = Array.from(quizProductItems).map(li => li.dataset.productId);
      let filteredScores = Object.entries(scores).filter(([id]) => availableIds.includes(id));

      // Sort by score, descending
      filteredScores.sort(([, a], [, b]) => b - a);

      // If less than 3 available, fill with top overall scores
      if (filteredScores.length < 3) {
        const remaining = Object.entries(scores)
          .filter(([id]) => !availableIds.includes(id))
          .sort(([, a], [, b]) => b - a);
        filteredScores = [...filteredScores, ...remaining].slice(0, 3);
      }

      const top3 = filteredScores.slice(0, 3).map(([id]) => id);

      localStorage.setItem('topProductIds', JSON.stringify(top3));
      showTopProducts(top3);

      localStorage.removeItem('quizAnswers');
      localStorage.setItem('quizFlag', "0");
    }
  })
  .catch(err => console.error("Error submitting quiz:", err));
}

// --- RESTORE TOP 3 ON PAGE LOAD --- //
if (reachedResultPage === 'true') {
  showResultPage();
  const storedTopIds = JSON.parse(localStorage.getItem('topProductIds') || '[]');
  if (storedTopIds.length) showTopProducts(storedTopIds);
}

// --- OTHER QUIZ FUNCTIONS --- //
setTimeout(() => loadingSpinnerSVG.classList.add('hidden'), 1000);

function handleLastNextButton(flag) {
  if (flag === allQuestionBoxes.length - 1) {
    showResultPage();
    localStorage.setItem("onResultPage", true);
    sendDataToAPI();
  }
}

function handleNext() {
  if (flag < allQuestionBoxes.length - 1) {
    flag++;
    saveState();
    allQuestionBoxes.forEach(box => box.classList.remove('active'));
    allQuestionBoxes[flag].classList.add('active');
    handlePrevVisibility();
    handleOutput(flag);
    handleStepProgress(flag);
    updateNextButtonState();
  } else {
    handleOutput(flag);
    handleLastNextButton(flag);
    loadingSpinnerSVG.classList.remove('hidden');
    setTimeout(() => loadingSpinnerSVG.classList.add('hidden'), 1000);
  }
}

function handlePrev() {
  if (flag > 0) {
    flag--;
    saveState();
    allQuestionBoxes.forEach(box => box.classList.remove('active'));
    allQuestionBoxes[flag].classList.add('active');
  }
  handlePrevVisibility();
  handleOutput(flag);
  handleStepProgress(flag);
  updateNextButtonState();
}

// --- RADIO INPUT LISTENERS --- //
allQuestionBoxes.forEach(box => {
  const currentQuestion = box.querySelector('.question').dataset.question;
  const radios = box.querySelectorAll('input[type="radio"]');

  if (seletedRadioValues[currentQuestion]) {
    radios.forEach(radio => {
      radio.checked = radio.value === seletedRadioValues[currentQuestion];
    });
  }

  radios.forEach(radio => {
    radio.addEventListener('change', function () {
      seletedRadioValues[currentQuestion] = this.value;
      saveState();
      updateNextButtonState();
    });
  });
});

// --- INIT PAGE STATE --- //
allQuestionBoxes.forEach(box => box.classList.remove('active'));
allQuestionBoxes[flag].classList.add('active');
handleStepProgress(flag);
handlePrevVisibility();
restoreInputsState();

// --- EVENT LISTENERS --- //
quizNextButton.addEventListener('click', handleNext);
quizPrevButton.addEventListener('click', handlePrev);

// --- Ensure Back/Forward Navigation Restores State --- //
window.addEventListener('pageshow', () => {
  seletedRadioValues = JSON.parse(localStorage.getItem("quizAnswers")) || {};
  restoreInputsState();
});
